const dict = {
  uk: {
    nav: {
      howItWorks: 'Як виглядає навчання',
      levelTest: 'Тест рівня',
      clubs: 'Клуби',
      kids: 'Для дітей',
      faq: 'Поширені питання',
      login: 'Вхід',
      register: 'Реєстрація',
    },
    hero: {
      badge: 'More than just English',
      titleLead: 'Англійська онлайн із фокусом на',
      titleAccent: 'результат',
      subtitle: 'Обирай свій формат — від індивідуальних занять до клубів за інтересами. Особиста програма за результатом тесту рівня.',
      ctaLevelTest: 'Пройти тест рівня',
      ctaHowItWorks: 'Як виглядає навчання',
    },
    pills: {
      speakingClub: 'Speaking Club',
      movieClub: 'Movie Club',
      bookClub: 'Book Club',
      aiAvatar: 'Розмовна практика з АІ аватаром',
      interactiveLessons: 'Інтерактивні уроки',
      individualLessons: 'Індивідуальні заняття',
      gameClub: 'Game Club',
      grammarClub: 'Grammar Club',
      kidsLessons: 'Уроки для дітей',
      groupLessons: 'Групові заняття',
      nmtPrep: 'Підготовка до НМТ',
      autoHomework: 'Домашка з автоперевіркою',
      freeLevelTest: 'Безкоштовний тест рівня',
    },
    mockup: {
      homework: {
        notes: 'Конспект',
        vocab: 'Словник',
        exercises: 'Вправи',
        submit: 'Перевірити відповіді та надіслати вчителю',
        solved: 'Кросворд розгадано!',
      },
      progress: {
        moduleTitle: 'Module 2: Past tenses · Тест',
        questionOf: 'Питання 5/5',
        passed: 'Тест пройдено!',
      },
      schedule: {
        title: 'Розклад',
        homeworkChip: 'Домашні завдання',
        reviewChip: 'Повторення',
        moduleTestsChip: 'Модульні тести',
        monthLabel: 'Травень 2026',
        weekdays: {
          mon: 'Пн', tue: 'Вт', wed: 'Ср', thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Нд',
        },
        classesLabel: 'Розклад занять',
        speakingClub: 'Speaking Club',
        indivLesson: 'Індивідуальне заняття',
        indivTitle: 'Урок з вчителем',
        dateMay16: '16 травня, Субота',
        join: 'Приєднатися',
        cancel: 'Скасувати',
      },
    },
    steps: {
      sectionTitle: 'Як виглядає навчання на Lingvish',
      sectionSubtitle: 'Це не просто Zoom із вчителем. Це повноцінна онлайн-кімната з усім, що потрібно для активного навчання.',
      presentations: {
        title: 'Інтерактивні презентації',
        desc: 'Під час уроку студент активно взаємодіє з презентацією, а не просто дивиться. Прямо на слайдах можна виконувати вправи, обирати правильні відповіді, писати, претягувати елементи і купу іншого.',
      },
      homework: {
        title: 'Домашні завдання з автоперевіркою',
        desc: 'Після завершення уроку кожен студент отримує домашнє завдання з конспектом та словником. Усі вправи автоматично перевіряються, а до кожної помилки є пояснення.',
      },
      progress: {
        title: 'Прогрес і модульні тести',
        desc: 'Після кожного модуля — тест на закріплення. Бачиш свій прогрес по кожному курсу.',
      },
      schedule: {
        title: 'Розклад і запис на клуби',
        desc: 'Бачиш усі свої заняття у календарі. Обираєш день — і одразу можеш записатись на Speaking Club, Movie Club чи інше.',
      },
    },
    program: {
      sectionTitle: 'Як побудована програма',
      sectionSubtitle: 'Кожен модуль — повний цикл з 8 уроків: від нового матеріалу до закріплення й перевірки.',
      step1: 'Інтерактивні уроки на платформі',
      step2: 'Домашні завдання',
      step3: 'Додаткові ігри на закріплення',
      step4: 'Модульний тест',
      step5: 'Додаткові уроки на повторення',
      optional: 'за потреби',
    },
    levelTest: {
      badge: 'Безкоштовно',
      title: 'Дізнайся свій рівень — і отримай персональну програму',
      subtitle: 'Комплексний тест перевіряє чотири навички — Listening, Speaking, Reading, Writing — визначає твій рівень за CEFR (від A1 до C2) і підбирає курс та вчителя під твої сильні й слабкі сторони.',
      cta: 'Пройти тест рівня',
      resultLabel: 'Результат',
      resultValue: 'A1 → C2 (CEFR)',
    },
    clubs: {
      badge: 'Клуби за інтересами',
      title: '5 клубів — кожен прокачує свій аспект мови',
      subtitle: 'Поза основними уроками — приєднуйся до клубів. Це жива практика з іншими учнями: дивимось, читаємо, говоримо, граємо.',
      cta: 'Записатися на заняття клубу',
      movie: {
        title: 'Movie Club',
        skill: 'Listening',
        desc: 'Дивимось уривки з фільмів, серіалів чи мультфільмів англійською. Розбираємо складану лексику та обговорюємо культурний контекст. Перегляд і обговорення фільму ідеально тренує розуміння на слух і живу мову.',
      },
      book: {
        title: 'Book Club',
        skill: 'Reading',
        desc: 'Обговорюємо враження від книги, аналізуємо уривки, розбираємо цікаві граматичні конструкції та лексику.',
      },
      speaking: {
        title: 'Speaking Club',
        skill: 'Speaking',
        desc: 'Розмовні зустрічі на різні теми. Долаєш мовний барʼєр і тренуєш fluency без оцінок і страху помилитись.',
      },
      grammar: {
        title: 'Grammar Club',
        skill: 'Grammar',
        desc: 'Ідеальна нагода розібратися зі складною граматикою або повторити те, що вже трохи забулося.',
      },
      game: {
        title: 'Game Club',
        skill: 'Fun practice',
        desc: 'Alias, Taboo, Pictionary та багато інших ігор допомогають практикувати лексику й граматику граючи і без зубріння.',
      },
    },
    kids: {
      badge: 'Окремо для дітей',
      title: 'Дитячі уроки з Кенгуру Кеном',
      subtitle: 'Дитячі курси побудовані як пригоди разом із кенгуру Кеном: уроки із сюжетною лінією, ігри та персонажі, які залучають дитину в навчання.',
      bullet1: 'Сюжетні уроки з персонажем, який супроводжує дитину протягом курсу',
      bullet2: 'Ігри, розфарбовки та інтерактивні вправи замість сухих правил',
      bullet3: 'Окремий кабінет дитини, який батьки можуть контролювати',
      cta: 'Зареєструвати дитину',
      kenAlt: 'Кенгуру Кен — маскот дитячих курсів Lingvish',
    },
    apps: {
      badge: 'Додаткова практика',
      title: 'Бібліотека книг в оригіналі',
      subtitle: 'Читай англомовні книги і одразу перекладай незнайомі слова — а ті, які хочеш запам’ятати, додавай у свій словник, щоб повторити пізніше.',
      reader: {
        title: 'Lingvish Reader',
        desc: 'Бібліотека електронних книг з умонтованим перекладачем. Тапни слово — побачиш переклад, транскрипцію і почуєш вимову. Тапни крапку — переклад усього речення. Слова, які хочеш вивчити, можна додати у свій словник і повторити пізніше через флешкарти й тести.',
        bullet1: 'Класика англійської літератури — Alice, Sherlock Holmes, Tom Sawyer',
        bullet2: 'Фільтри за рівнем A1-C2 і жанром',
        bullet3: 'Флешкарти і тести зі spaced repetition',
        bullet4: 'Читай у браузері з будь-якого пристрою',
        openBtn: 'Відкрити бібліотеку',
      },
    },
    faq: {
      badge: 'FAQ',
      title: 'Відповіді на поширені питання',
      subtitle: 'Найчастіші запитання про навчання на Lingvish Space.',
      q1: {
        q: 'Що таке безкоштовна консультація?',
        a: 'Це телефонна розмова з нашим менеджером, який дасть відповіді на всі запитання, допоможе обрати персоналізований формат навчання, підбере зручний час і дні для занять та за потреби допоможе зареєструватися. Без оплати й без зобовʼязань.',
      },
      q2: {
        q: 'Як формується графік занять?',
        a: 'Ти обираєш зручні дні та години самостійно при записі на заняття через свій кабінет, або вказуєш бажані дні та години під час телефонної консультації. Після цього твій розклад відображається в твоєму особистому кабінеті.',
      },
      q3: {
        q: 'Що робити, якщо не вдається підʼєднатися до уроку?',
        a: 'Спочатку перевір інтернет-зʼєднання та оновлення браузера. Якщо проблема не зникла — напиши вчителю в чаті платформи або звернись у підтримку.',
      },
      q4: {
        q: 'Як перенести урок?',
        a: 'Індивідуальні заняття можна перенести за 4 години до початку уроку на вільний слот часу вашого викладача. На місяць дається два безкоштовних перенесення. Заняття клубу не можна перенести, лише безкоштовно скасувати за 4 години до початку. Групові заняття не скасовуються і не переносяться, але якщо Ви його пропустили, то можете переглянути запис заняття, попрацювати з конспектом, виконати домашнє, а за потреби поставити питання викладачу в чаті.',
      },
      q5: {
        q: 'Як скасувати урок?',
        a: 'У розділі «Розклад» натисни «Скасувати» поряд із заняттям. Безкоштовне скасування доступне за 4 години до початку — після цього часу урок зараховується. Проте заняття групи не скасовуються. Якщо ти пропустиш заняття, то можеш подивитися запис уроку поряд з конспектом, словником та домашнім завданням.',
      },
      q6: {
        q: 'Як довго триває урок?',
        a: 'Всі заняття на платформі тривають 60 хв — групові, індивідуальні, а також заняття клубів.',
      },
    },
    cta: {
      title: 'Готовий почати?',
      subtitle: 'Створи акаунт, пройди тест рівня — і ми підберемо тобі програму та вчителя.',
      createAccount: 'Створити акаунт',
      haveAccount: 'У мене вже є акаунт',
    },
    footer: {
      tagline: 'More than just English',
      description: 'Сучасна платформа для вивчення англійської онлайн.',
      navigationTitle: 'Навігація',
      shop: 'Магазин',
      dictionary: 'Словник',
      contactsTitle: 'Контакти',
      socialsTitle: 'Соціальні мережі',
      rights: '© 2026 LINGVISH SPACE. Всі права захищені.',
    },
  },
  en: {
    nav: {
      howItWorks: 'How it works',
      levelTest: 'Level test',
      clubs: 'Clubs',
      kids: 'For kids',
      faq: 'FAQ',
      login: 'Log in',
      register: 'Sign up',
    },
    hero: {
      badge: 'More than just English',
      titleLead: 'English online focused on',
      titleAccent: 'results',
      subtitle: 'Choose your format — from private lessons to interest-based clubs. A personal program built from your placement test.',
      ctaLevelTest: 'Take the level test',
      ctaHowItWorks: 'How it works',
    },
    pills: {
      speakingClub: 'Speaking Club',
      movieClub: 'Movie Club',
      bookClub: 'Book Club',
      aiAvatar: 'Conversation practice with an AI avatar',
      interactiveLessons: 'Interactive lessons',
      individualLessons: 'Private lessons',
      gameClub: 'Game Club',
      grammarClub: 'Grammar Club',
      kidsLessons: 'Kids lessons',
      groupLessons: 'Group lessons',
      nmtPrep: 'NMT exam prep',
      autoHomework: 'Auto-checked homework',
      freeLevelTest: 'Free level test',
    },
    mockup: {
      homework: {
        notes: 'Notes',
        vocab: 'Vocabulary',
        exercises: 'Exercises',
        submit: 'Check answers and send to teacher',
        solved: 'Crossword solved!',
      },
      progress: {
        moduleTitle: 'Module 2: Past tenses · Test',
        questionOf: 'Question 5/5',
        passed: 'Test passed!',
      },
      schedule: {
        title: 'Schedule',
        homeworkChip: 'Homework',
        reviewChip: 'Review',
        moduleTestsChip: 'Module tests',
        monthLabel: 'May 2026',
        weekdays: {
          mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun',
        },
        classesLabel: 'Class schedule',
        speakingClub: 'Speaking Club',
        indivLesson: 'Private lesson',
        indivTitle: 'Lesson with teacher',
        dateMay16: 'May 16, Saturday',
        join: 'Join',
        cancel: 'Cancel',
      },
    },
    steps: {
      sectionTitle: 'What learning on Lingvish looks like',
      sectionSubtitle: 'This is not just Zoom with a teacher. It is a full online classroom with everything you need for active learning.',
      presentations: {
        title: 'Interactive presentations',
        desc: 'During a lesson students actively interact with the slides instead of just watching. They complete exercises, pick answers, type, drag elements, and much more — right on the slide.',
      },
      homework: {
        title: 'Homework with auto-checking',
        desc: 'After every lesson each student gets homework with notes and a vocabulary list. All exercises are checked automatically, and every mistake comes with an explanation.',
      },
      progress: {
        title: 'Progress and module tests',
        desc: 'After every module — a test to consolidate what you learned. You see your progress in every course.',
      },
      schedule: {
        title: 'Schedule and club sign-up',
        desc: 'You see all your classes in the calendar. Pick a day — and sign up for Speaking Club, Movie Club or anything else in one click.',
      },
    },
    program: {
      sectionTitle: 'How the program is built',
      sectionSubtitle: 'Every module is a full cycle of 8 lessons: from new material to practice and review.',
      step1: 'Interactive lessons on the platform',
      step2: 'Homework',
      step3: 'Extra games for practice',
      step4: 'Module test',
      step5: 'Extra review lessons',
      optional: 'if needed',
    },
    levelTest: {
      badge: 'Free',
      title: 'Find out your level — and get a personal program',
      subtitle: 'A comprehensive test checks all four skills — Listening, Speaking, Reading, Writing — pinpoints your CEFR level (A1 to C2) and matches a course and teacher to your strengths and weaknesses.',
      cta: 'Take the level test',
      resultLabel: 'Result',
      resultValue: 'A1 → C2 (CEFR)',
    },
    clubs: {
      badge: 'Interest-based clubs',
      title: '5 clubs — each one boosts a different side of your English',
      subtitle: 'Beyond your regular lessons — join our clubs. Live practice with other students: we watch, read, talk, and play together.',
      cta: 'Sign up for a club session',
      movie: {
        title: 'Movie Club',
        skill: 'Listening',
        desc: 'We watch clips from films, series and cartoons in English. We break down tricky vocabulary and discuss cultural context. Watching and discussing a film is perfect training for listening comprehension and real-life English.',
      },
      book: {
        title: 'Book Club',
        skill: 'Reading',
        desc: 'We share impressions of the book, analyze passages, and explore interesting grammar structures and vocabulary.',
      },
      speaking: {
        title: 'Speaking Club',
        skill: 'Speaking',
        desc: 'Conversational meetups on different topics. Break the language barrier and train fluency without grades and without fear of mistakes.',
      },
      grammar: {
        title: 'Grammar Club',
        skill: 'Grammar',
        desc: 'The perfect chance to sort out tricky grammar or refresh what you might have forgotten.',
      },
      game: {
        title: 'Game Club',
        skill: 'Fun practice',
        desc: 'Alias, Taboo, Pictionary and many other games help you practice vocabulary and grammar while playing — no cramming.',
      },
    },
    kids: {
      badge: 'Just for kids',
      title: "Kids' lessons with Ken the Kangaroo",
      subtitle: 'Our kids courses are built as adventures with Ken the Kangaroo: story-driven lessons, games, and characters that pull children into learning.',
      bullet1: 'Story-based lessons with a character who guides the child through the course',
      bullet2: 'Games, coloring and interactive exercises instead of dry rules',
      bullet3: 'A separate child account that parents can supervise',
      cta: 'Sign up my child',
      kenAlt: 'Ken the Kangaroo — mascot of Lingvish kids courses',
    },
    apps: {
      badge: 'Extra practice',
      title: 'Library of books in the original',
      subtitle: 'Read English books and translate unfamiliar words on the fly — save the ones you want to remember to your personal dictionary and review them later.',
      reader: {
        title: 'Lingvish Reader',
        desc: 'An e-book library with a built-in translator. Tap a word — see its translation, transcription and hear the pronunciation. Tap a period — get the whole sentence translated. Save the words you want to learn to your personal dictionary and review them later with flashcards and quizzes.',
        bullet1: 'English literary classics — Alice, Sherlock Holmes, Tom Sawyer',
        bullet2: 'Filters by CEFR level A1–C2 and genre',
        bullet3: 'Flashcards and quizzes with spaced repetition',
        bullet4: 'Read in the browser on any device',
        openBtn: 'Open library',
      },
    },
    faq: {
      badge: 'FAQ',
      title: 'Answers to common questions',
      subtitle: 'The most frequent questions about learning at Lingvish Space.',
      q1: {
        q: 'What is the free consultation?',
        a: 'It is a phone call with our manager, who answers all your questions, helps you choose a personalized learning format, picks convenient days and times, and helps you register if needed. No payment, no commitment.',
      },
      q2: {
        q: 'How is the class schedule built?',
        a: 'You pick convenient days and times yourself when signing up for lessons in your account, or you tell us your preferred days and times during the phone consultation. Your schedule then appears in your personal account.',
      },
      q3: {
        q: "What should I do if I can't connect to a lesson?",
        a: 'First check your internet connection and update your browser. If the problem persists — message your teacher in the platform chat or contact support.',
      },
      q4: {
        q: 'How do I reschedule a lesson?',
        a: 'Private lessons can be rescheduled up to 4 hours before the start time to any free slot in your teacher\'s calendar. Two free reschedules are included per month. Club sessions cannot be rescheduled, only cancelled for free up to 4 hours before the start. Group lessons cannot be cancelled or rescheduled, but if you miss one you can watch the recording, work with the notes, do the homework, and ask the teacher any questions in the chat.',
      },
      q5: {
        q: 'How do I cancel a lesson?',
        a: 'In the “Schedule” section, click “Cancel” next to the lesson. Free cancellation is available up to 4 hours before the start — after that the lesson still counts. Group classes cannot be cancelled. If you miss a class you can watch the recording alongside the notes, vocabulary and homework.',
      },
      q6: {
        q: 'How long does a lesson last?',
        a: 'All classes on the platform last 60 minutes — group, private, and club sessions.',
      },
    },
    cta: {
      title: 'Ready to start?',
      subtitle: 'Create an account, take the level test — and we\'ll match you with a program and a teacher.',
      createAccount: 'Create account',
      haveAccount: 'I already have an account',
    },
    footer: {
      tagline: 'More than just English',
      description: 'A modern platform for learning English online.',
      navigationTitle: 'Navigation',
      shop: 'Shop',
      dictionary: 'Dictionary',
      contactsTitle: 'Contact',
      socialsTitle: 'Social media',
      rights: '© 2026 LINGVISH SPACE. All rights reserved.',
    },
  },
};

export default dict;
